function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconError = function SvgIconError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd"
    },
    d: "M25,15A10,10,0,1,1,15,25,10,10,0,0,1,25,15Zm0,8,2.82-2.83a1.4,1.4,0,0,1,2,2L27,25l2.83,2.82a1.41,1.41,0,0,1-2,2L25,27,22.16,29.8a1.4,1.4,0,0,1-2-2L23,25,20.2,22.16a1.39,1.39,0,0,1,2-2Z"
  });
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-error.50074bf6.svg";
export { ForwardRef as ReactComponent };